/* eslint-disable */
import throwModelNotFoundByIdError from '../../Errors/Model/ModelNotFoundById.error';
import { deliveriesFixture } from './Delivery.service.fixture';

/**
 * Handle delivery tasks
 * @class MockDeliveryService
 */
class MockDeliveryService {
  /**
   * Creates an instance of `MockDeliveryService`
   * @param {DeliveryServiceCreateDto} dto The params required to create an instance of `MockDeliveryService`
   * @memberof MockDeliveryService
   */
  constructor({ httpService }) {
    this.httpService = httpService;
  }

  /**
   * Fetch all known deliveries
   * @returns {Promise<Array<DeliveryEntity>>} The deliveries
   * @memberof MockDeliveryService
   */
  all = async () => {
    return deliveriesFixture;
  };

  /**
   * Find an delivery by its `id`
   * @param {DeliveryServiceFindByIdDto} dto The required params to find an delivery by its `id`
   * @returns {Promise<DeliveryEntity>} The found delivery
   * @memberof MockDeliveryService
   */
  findById = async ({ id }) => {
    const foundDelivery = deliveriesFixture.find((delivery) => delivery.docketId === id);
    if (foundDelivery === undefined) {
      throwModelNotFoundByIdError(`delivery`, id);
    }
    return foundDelivery;
  };

  /**
   * Update a delivery with a specific `id`
   * @param {DeliveryServiceUpdateByIdDto} dto The required params to update a delivery with a specific `id`
   * @returns {Promise<DeliveryEntity>} The found delivery
   * @memberof MockDeliveryService
   */
  updateById = async ({ changes, id }) => {
    const index = deliveriesFixture.findIndex((delivery) => delivery.docketId === id);
    if (index === -1) {
      throwModelNotFoundByIdError(`delivery`, id);
    }
    deliveriesFixture[index] = {
      ...deliveriesFixture[index],
      ...changes,
    };
    return deliveriesFixture[index];
  };
}

export default MockDeliveryService;
